// "Do you have any household pets?" — the same question, in English or
// Spanish, wherever a family applies (IntakeForm, Referral). The answer is
// { pets, other, notes }; lib/pets.js turns it into columns.
import { PET_OPTIONS, PET_LABELS, PET_COPY, togglePet } from '../lib/pets';

export default function PetsQuestion({ lang = 'en', value, onChange, error, required = true, hint }) {
  const copy = PET_COPY[lang] || PET_COPY.en;
  const labels = PET_LABELS[lang] || PET_LABELS.en;
  const pets = value.pets || [];
  const update = (patch) => onChange({ ...value, ...patch });

  return (
    <div className="form-group">
      <label className="form-label" id="pets-question">{copy.question}{required && <span className="req"> *</span>}</label>
      <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 8 }}>{hint || copy.hint}</div>
      <div role="group" aria-labelledby="pets-question" style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {PET_OPTIONS.map(key => {
          const on = pets.includes(key);
          return (
            <label key={key} style={{
              display: 'inline-flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13,
              padding: '8px 14px', borderRadius: 8,
              border: `1px solid ${on ? 'var(--accent)' : 'var(--border)'}`,
              background: on ? 'var(--accent-bg)' : 'var(--card-bg)', color: 'var(--text)',
            }}>
              <input type="checkbox" checked={on} onChange={() => update({ pets: togglePet(pets, key) })} />
              {labels[key]}
            </label>
          );
        })}
      </div>
      {pets.includes('other') && (
        <div style={{ marginTop: 12 }}>
          <label className="form-label" htmlFor="pets-other">{copy.otherLabel}<span className="req"> *</span></label>
          <input id="pets-other" className="form-input" value={value.other || ''} maxLength={200}
            placeholder={copy.otherPlaceholder} onChange={e => update({ other: e.target.value })} />
        </div>
      )}
      {pets.length > 0 && !pets.includes('none') && (
        <div style={{ marginTop: 12 }}>
          <label className="form-label" htmlFor="pets-notes">{copy.notesLabel}</label>
          <input id="pets-notes" className="form-input" value={value.notes || ''} maxLength={300}
            placeholder={copy.notesPlaceholder} onChange={e => update({ notes: e.target.value })} />
        </div>
      )}
      {error && <div style={{ fontSize: 12, color: 'var(--danger)', marginTop: 6 }}>{copy[error] || error}</div>}
    </div>
  );
}
